module.exports = __webpack_public_path__ + "static/media/6. Transparencias, Resina epóxica sobre lámina acrilico, 97 x 160 x 10 cm, 2020 copy.866d0280.png";